import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { RiLightbulbFlashLine, RiEditFill, RiSearchLine } from "react-icons/ri";
import EmbedCode from '../components/EmbedCode';
import CreateEvent from '../components/CreateEvent';
import axios from 'axios';
import ChnageStatus from '../components/ChnageStatus';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { getSaveUsers } from "../utilities/common"


async function getGlobalEvents() {
    var events
    await axios.get('https://8cey5qp1e0.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Node18')
        .then((res) => events = res.data.Items.sort(function (a, b) { return new Date(b.created_date) - new Date(a.created_date) }))
        .catch(err => console.log(err))
    return events
}


export default function Home2({ itemsPerPage = 5 }) {

    let navigate = useNavigate();

    useEffect(() => {
        let data = getSaveUsers()
        if (data === null) {
            navigate("/");

        }
    }, [])

    const [showModal, setShowModal] = useState(false)
    const [showEmbedModal, setShowEmbedModal] = useState(false)
    const [listEvents, setListEvents] = useState([])

    const [todayDate, setTodayDate] = useState("")
    const [embedData, setembedData] = useState()
    const [todayDateStatus, setTodayDateStatus] = useState("active")

    const [eventAction, setEventAction] = useState("add")

    // We start with an empty list of items.
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    const [filterMenu, setFilterMenu] = useState("LIVE")

    // const [itemsPerPage, setItemsPerPage] = useEffect(4)

    const [currentEditItem, setCurrentEditItem] = useState()
    const [fullListItems, setFullListItems] = useState()
    const [searchEventItems, setSearchEventItems] = useState()

    useEffect(() => {
        // getEvents()
        const datetime = new Date();
        let date = datetime.getDate() + "-" + (datetime.getMonth() + 1) + "-" + datetime.getFullYear()
        setTodayDate(date)

    }, [])
    const getEvents = async (filter, search) => {
        console.log(filter, search, searchEventItems)
        // if (searchEventItems) {
        //     search = "search"
        // }

        var events
        await axios.get('https://8cey5qp1e0.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Node18')
            .then((res) => {
                events = res.data.Items.sort(function (a, b) { return new Date(b.created_date) - new Date(a.created_date) })
                setFullListItems(events)
                const endOffset = itemOffset + itemsPerPage;
                if (filter === "ALL" && !search) {
                    setCurrentItems(events.slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(events.length / itemsPerPage));
                    eventListCard(currentItems)
                } else if (filter === "LIVE" && search == "search") {
                    setCurrentItems(events.filter(e => e.status === filter).filter((e) => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(events.filter(e => e.status === filter).filter((e) => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).length / itemsPerPage));
                    eventListCard(currentItems)

                } else if (filter === "CLOSE" && search == "search") {
                    setCurrentItems(events.filter(e => e.status === filter).filter((e) => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(events.filter(e => e.status === filter).filter((e) => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).length / itemsPerPage));
                    eventListCard(currentItems)

                } else if (filter === "ALL" && search == "search") {
                    setCurrentItems(events.filter(e => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(events.filter(e => e.event_name.toUpperCase().includes(searchEventItems.toUpperCase())).length / itemsPerPage));
                    // setItemOffset(0)
                    eventListCard(currentItems)

                } else {
                    setCurrentItems(events.filter(e => e.status === filter).slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(events.filter(e => e.status === filter).length / itemsPerPage));
                    eventListCard(currentItems)

                }


            })
            .catch(err => console.log(err))
        return events

    }

    useEffect(async () => {
        // Fetch items from another resources.
        await getEvents(filterMenu)

        // const endOffset = itemOffset + itemsPerPage;
        // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        // await setCurrentItems(ev.slice(itemOffset, endOffset));
        // setPageCount(Math.ceil(ev.length / itemsPerPage));

        // console.log(ev)

        console.log(itemOffset)

    }, [itemOffset, itemsPerPage]);

    const convertdate = (datetime) => {
        let date = new Date(datetime).getDate() + "-" + (new Date(datetime).getMonth() + 1) + "-" + new Date(datetime).getFullYear()
        return date
    }

    const convertBeforeDate = (date) => {
        const todayDate = new Date();
        let isBefore = moment(new Date(date).getFullYear() + "-" + (new Date(date).getMonth() + 1) + "-" + new Date(date).getDate()).isBefore(todayDate.getFullYear() + "-" + todayDate.getMonth() + "-" + todayDate.getDate())
        if (isBefore === true) {
            return "Past"
        }
        else if (isBefore === false) {
            return "Active"
        }

        return isBefore

    }


    const setChangeView = (id, cat, name) => {

        console.log(cat)

        let category
        if (cat === "GENERAL") {
            category = "0"
        } else if (cat === "CRICKET") {
            category = "1"

        } else if (cat === "FOOTBALL") {
            category = "2"

        } else if (cat === undefined) {
            category = "0"
        }

        else if (parseInt(cat) > 2) {
            category = "0"
        }

        // console.log(`/event/${id}/${category}/${name}`)

        // navigate(`/event/${id}/${category}/${name}`);
        navigate(`/event/${id}/${name}`);

    }

    const createEventClick = (action, data) => {
        setShowModal(true)
        setEventAction(action)
        setCurrentEditItem(data)
    }

    const embedCodeClick = (data) => {
        setembedData(data)
        setShowEmbedModal(true)
    }

    const closeModal = async () => {
        await setSearchEventItems()
        window.location.reload(true);

        let data = await getEvents(filterMenu, "search")

        setShowModal(false)

        eventListCard(data)
        setItemOffset(0);

    }

    const handlePageClick = async (event) => {
        let ev = await getEvents(filterMenu, "search")
        let newOffset
        // if (filterMenu === "ALL") {
        newOffset = (event?.selected * itemsPerPage) % ev?.length;
        // }
        // else {
        // newOffset = (0 * itemsPerPage) % ev?.length;
        // }
        setItemOffset(newOffset);

    }

    const clickFilterMenu = async (filter, event) => {
        await setSearchEventItems("")

        await setFilterMenu(filter)
        let data = await getEvents(filter)

        if (filter === "ALL") {
            eventListCard(data)
            setItemOffset(0);
        } else {
            eventListCard(data)
            setItemOffset(0);
        }
    }

    const searchEvents = async (text) => {

        setSearchEventItems(text)
        setItemOffset(0);

    }

    const submitEvents = async () => {
        let data = await getEvents(filterMenu, "search")

        // let eventList = data.filter(e => e.event_name == searchEventItems)
        // setItemOffset(0);

        eventListCard(data)
    }


    const eventListCard = (dataItem) => {
        console.log(dataItem)
        let resultData = []
        if (dataItem?.length > 0) {

            dataItem?.map((data, index) =>
                resultData.push(<div class={`card border-0 my-2 l-cursor ps-2 ${data?.status === "LIVE" ? "pt-2" : "py-2"}`} key={data.Id}>
                    {data?.status === "LIVE" ?
                        <div className="l-badge d-flex align-items-center ms-md-2 mt-2 " onClick={() => ChnageStatus()}>
                            <div className="live-blink me-1"></div>LIVE
                        </div> : ""}
                    <div class="card-body d-flex justify-content-between l-event-card-body px-2 py-2 pb-3">

                        <div className="l-event-heading-container">
                            <div className="l-event-heading d-flex ">
                                <h3 className="mt-2 mt-md-0 m-0 " style={{ textTransform: "capitalize" }} onClick={() => setChangeView(data.Id, "CRICKET", data.event_name)}>{data.event_name}</h3>
                                <RiEditFill size={16} className='mx-2' onClick={() => createEventClick("edit", data)}></RiEditFill>

                            </div>
                            <div className="l-event-functions mt-md-2 my-2 my-md-0">
                                <button type="button" class="btn l-btn text-white me-4" onClick={() => setChangeView(data.Id, "8", data.event_name)}>Add News</button>
                                <button type="button" class="btn l-btn text-white" onClick={() => embedCodeClick(data)}>Embed Code</button>
                            </div>
                        </div>
                        <div className="l-event-card-created">
                            <h6 className={`m-0 fw-bold l-date l-status`}>{data?.status === "LIVE" ? "Active" : "Closed"}</h6>
                            <p className="m-0 l-date">Created on: {convertdate(data?.created_date)}</p>
                            <p className="m-0 l-date">Created by: {data?.created_at}</p>
                            <p className="m-0 l-date">Updated by: {data?.updated_at}</p>
                        </div>
                    </div>

                </div>
                ))

            return resultData
        }
        else {
            return (<h3>No matching results found</h3>)
        }
    }

    return (
        <div>
            <Layout>

                <div className='d-flex justify-content-between'>
                    <div>
                        <button type="button" class="btn l-create-btn text-white d-flex align-items-center l-cursor" onClick={() => createEventClick("add")}><RiLightbulbFlashLine size={24} className="mx-2"></RiLightbulbFlashLine>Create Event</button>

                    </div>
                    <div className='d-flex'>
                        <div class="dropdown mx-3">
                            <p class="btn btn-secondary dropdown-toggle text-white" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                {filterMenu}
                            </p>

                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <li className='cursor l-cursor' value="All" onClick={() => clickFilterMenu("ALL")}>ALL</li>
                                <li className='cursor l-cursor' value="Live" onClick={() => clickFilterMenu("LIVE")}>LIVE</li>
                                <li className='cursor l-cursor' value="Close" onClick={() => clickFilterMenu("CLOSE")} >CLOSED</li>
                            </ul>
                        </div>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="search" aria-label="Username" aria-describedby="basic-addon1" value={searchEventItems} onChange={(e) => searchEvents(e.target.value)} />
                            <span class="input-group-text l-cursor" id="basic-addon1" onClick={() => submitEvents()}><RiSearchLine></RiSearchLine></span>

                        </div>
                    </div>

                </div>


                <div className="l-events-list mt-3">

                    {/* <h3>Events List</h3> */}

                    {eventListCard(currentItems)}


                </div>


                <div className="mt-4 d-flex justify-content-center">

                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=">>"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="<<"
                        renderOnZeroPageCount={null}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item "
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link "
                        
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="ps-0 pagination"
                        activeClassName="active text-white"
                    />
                </div>
            </Layout>
            <CreateEvent showModal={showModal} closeModal={() => closeModal()} eventAction={eventAction} currentEditItem={currentEditItem}></CreateEvent>

            <EmbedCode data={embedData} showEmbedModal={showEmbedModal} closeModal={() => setShowEmbedModal(false)}></EmbedCode>

        </div>
    )
}
